enum ParentNumberEnum {
  OneParent = 1,
  TwoParents = 2,
}

export default ParentNumberEnum;
